/**
 * Common request/response interfaces for API operations
 */

/**
 * Generic response for user operations
 */
export interface InlineResponse200 {
  userId?: number;
  authKey?: string;
  name?: string;
  email?: string;
  nickname?: string;
  pictureUrl?: string | null;
  createdAt?: string;
  integrationIds?: number[] | null;
  adminPermIds?: number[] | null;
  lastLogin?: number | null;
  loginProvider?: string | null;
}

/**
 * Response for user info operations
 */
export interface InlineResponse2001 {
  userId: number;
  name: string;
  email: string;
  nickname: string;
  createdAt: string;
  lastLogin?: number | null;
}

/**
 * Response for version creation operations
 */
export interface InlineResponse2002 {
  versionId: number;
  projectId: number;
  majorVersion: number;
  minorVersion: number;
  createdAt: string;
  defaultState: string;
  defaultWorkflowId?: number | null;
}

/**
 * Request body for version operations
 */
export interface VVersionIdBody {
  defaultState?: string;
  defaultWorkflowId?: number | null;
}

/**
 * Integration interface
 */
export interface Integration {
  integrationId: number;
  name: string;
  displayName: string;
}

/**
 * Arrow alias interfaces
 */
export interface ArrowAlias {
  aliasId: number;
  projectId: number;
  name: string;
  url: string;
  token: string;
  verified: boolean;
  createdAt: string;
  modifiedAt: string;
  verifiedAt?: string | null;
  cloudBased: boolean;
  cloudConfig?: string | null;
  passwordSecretId?: number | null;
}

export interface NewAliasParams {
  name: string;
  url: string;
  token: string;
  cloudBased: boolean;
  cloudConfig?: string | null;
  cloudConfigSecret?: string | null;
  passwordSecretId?: number | null;
}

export interface SaveAliasParams {
  name?: string | null;
  url?: string | null;
  cloudBased?: boolean | null;
  cloudConfig?: string | null;
  cloudConfigSecret?: string | null;
  passwordSecretId?: number | null;
}

/**
 * Database alias interfaces (deprecated)
 */
export interface DBAlias {
  dbAliasId: number;
  projectId: number;
  name: string;
  createdAt: string;
  modifiedAt: string;
  host: string;
  port: string;
  username: string;
  dbname: string;
  options?: string | null;
  passwordSecretId?: number | null;
}

export interface DBAliasSave {
  dbAliasId: number;
  projectId: number;
  name: string;
  host: string;
  port: string;
  username: string;
  dbname: string;
  options?: string | null;
  passwordSecretId?: number | null;
}

/**
 * Request body for updating user information
 */
export interface UsersCurrentBody {
  name?: string | null;
  nickname?: string | null;
  pictureUrl?: string | null;
  timezone?: string | null;
  jobTitle?: string | null;
}













